import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=22e38d43"
import script from "./myInvoice.vue?vue&type=script&lang=js"
export * from "./myInvoice.vue?vue&type=script&lang=js"
import style0 from "./myInvoice.vue?vue&type=style&index=0&id=22e38d43&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports